var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixForumV1Category from '@wix/ambassador-forum-v1-category/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var HeaderType;
(function (HeaderType) {
    HeaderType["NONE"] = "NONE";
    HeaderType["COLOR"] = "COLOR";
    HeaderType["IMAGE"] = "IMAGE";
})(HeaderType || (HeaderType = {}));
export var PostType;
(function (PostType) {
    PostType["DISCUSSION"] = "DISCUSSION";
    PostType["QUESTION"] = "QUESTION";
})(PostType || (PostType = {}));
export var Access;
(function (Access) {
    Access["UNKNOWN"] = "UNKNOWN";
    Access["PUBLIC"] = "PUBLIC";
    Access["MEMBERS_ONLY"] = "MEMBERS_ONLY";
    Access["PRIVATE"] = "PRIVATE";
})(Access || (Access = {}));
export var Interaction;
(function (Interaction) {
    Interaction["UNKNOWN"] = "UNKNOWN";
    Interaction["REACTION"] = "REACTION";
    Interaction["VOTE"] = "VOTE";
    Interaction["NONE"] = "NONE";
})(Interaction || (Interaction = {}));
export var Type;
(function (Type) {
    Type["LIKE"] = "LIKE";
    Type["ANGRY"] = "ANGRY";
    Type["CLAP"] = "CLAP";
    Type["LOVE"] = "LOVE";
    Type["HAHA"] = "HAHA";
    Type["SAD"] = "SAD";
    Type["SMILE"] = "SMILE";
    Type["WOW"] = "WOW";
    Type["THINKING"] = "THINKING";
    Type["THUMBS_UP"] = "THUMBS_UP";
    Type["THUMBS_DOWN"] = "THUMBS_DOWN";
})(Type || (Type = {}));
export var PostInteraction;
(function (PostInteraction) {
    PostInteraction["UNKNOWN"] = "UNKNOWN";
    PostInteraction["REACTION"] = "REACTION";
    PostInteraction["NONE"] = "NONE";
})(PostInteraction || (PostInteraction = {}));
export var CommentOrder;
(function (CommentOrder) {
    CommentOrder["UNKNOWN"] = "UNKNOWN";
    CommentOrder["OLDEST"] = "OLDEST";
    CommentOrder["NEWEST"] = "NEWEST";
    CommentOrder["MOST_VOTES"] = "MOST_VOTES";
    CommentOrder["LEAST_VOTES"] = "LEAST_VOTES";
    CommentOrder["LOWEST_RATED"] = "LOWEST_RATED";
    CommentOrder["HIGHEST_RATED"] = "HIGHEST_RATED";
    CommentOrder["MOST_REACTIONS"] = "MOST_REACTIONS";
})(CommentOrder || (CommentOrder = {}));
export var CategoryFieldField;
(function (CategoryFieldField) {
    CategoryFieldField["UNKNOWN"] = "UNKNOWN";
    /** Includes the category's URL. */
    CategoryFieldField["URL"] = "URL";
})(CategoryFieldField || (CategoryFieldField = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN"] = "UNKNOWN";
    /** URL of the category. */
    Field["URL"] = "URL";
})(Field || (Field = {}));
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _category = {
    headerImage: 'wix.common.Image',
    url: 'wix.common.PageUrl',
};
const _categoryRequest = {};
const _categoryResponse = { category: '_category' };
const _categorySlugRequest = {};
const _createCategoryRequest = { category: '_category' };
const _deleteCategoryRequest = {};
const _deleteCategoryResponse = { category: '_category' };
const _markAllPostsAsReadRequest = {};
const _markAllPostsAsReadResponse = {};
const _markCategoryReadRequest = {};
const _markCategoryReadResponse = {};
const _queryCategoriesRequest = {};
const _queryCategoriesResponse = { categories: '_category' };
const _subscribeContactToCategoryRequest = {};
const _subscribeContactToCategoryResponse = {};
const _unsubscribeContactFromCategoryRequest = {};
const _unsubscribeContactFromCategoryResponse = {};
const _updateCategoryRequest = { category: '_category' };
/**
 * Returns a single category by ID.
 * @param categoryId - ID of the retrieved category.
 * @public
 * @documentationMaturity preview
 * @requiredField categoryId
 * @param options - Options specifying which fields to return.
 * @adminMethod
 * @returns Retrieved category for the provided category ID.
 */
export function getCategory(categoryId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            categoryId: '$[0]',
            fieldsToInclude: '$[1].fieldsToInclude',
            extraFields: '$[1].extraFields',
        };
        const responseTransformation = '$.category';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _categoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _categoryResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId, options]);
        const reqOpts = ambassadorWixForumV1Category.getCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns a single category by URL slug.
 * @param slug - URL slug.
 * @public
 * @documentationMaturity preview
 * @requiredField slug
 * @param options - Options specifying which fields to return.
 * @adminMethod
 */
export function getCategoryBySlug(slug, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            slug: '$[0]',
            fieldsToInclude: '$[1].fieldsToInclude',
            extraFields: '$[1].extraFields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _categorySlugRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _categoryResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([slug, options]);
        const reqOpts = ambassadorWixForumV1Category.getCategoryBySlug(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'slug',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of categories, given the provided paging, filtering, and sorting.
 *
 * Query Categories runs with these defaults, which you can override:
 *
 * - `paging.limit` is `10`
 * - `paging.offset` is `0`
 *
 * For field support for filters and sorting,
 * see [Categories: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-forum/wix-forum/filter-and-sort#category-api-supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @public
 * @documentationMaturity preview
 * @param options - Options for sorting, filtering, paging, and specifying return fields.
 * @adminMethod
 */
export function queryCategories(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            paging: '$[0].paging',
            filter: '$[0].filter',
            sort: '$[0].sort',
            fieldsToInclude: '$[0].fieldsToInclude',
            extraFields: '$[0].extraFields',
            skipMetaData: '$[0].skipMetaData',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryCategoriesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryCategoriesResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['Array#categories']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixForumV1Category.queryCategories(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Marks category as read for identity who made a request.
 * @param categoryId - ID of the read category.
 * @internal
 * @documentationMaturity preview
 * @requiredField categoryId
 * @adminMethod
 */
export function markCategoryRead(categoryId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { categoryId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _markCategoryReadRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _markCategoryReadResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId]);
        const reqOpts = ambassadorWixForumV1Category.markCategoryRead(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Marks all category posts as read for identity who made a request. If categoryId is not provided it marks all posts in the forum as read
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function markAllPostsAsRead(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { categoryId: '$[0].categoryId' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _markAllPostsAsReadRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _markAllPostsAsReadResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixForumV1Category.markAllPostsAsRead(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new category.
 * @internal
 * @documentationMaturity preview
 * @requiredField options.category.description
 * @requiredField options.category.name
 * @adminMethod
 * @returns Retrieved category for the provided category ID.
 */
export function createCategory(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { category: '$[0].category' };
        const responseTransformation = '$.category';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createCategoryRequest,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _categoryResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixForumV1Category.createCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a category's fields according to `fieldMask`.
 * @param categoryId - ID of category.
 * @internal
 * @documentationMaturity preview
 * @requiredField categoryId
 * @adminMethod
 * @returns Retrieved category for the provided category ID.
 */
export function updateCategory(categoryId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            categoryId: '$[0]',
            fieldMask: '$[1].fieldMask',
            category: '$[1].category',
        };
        const responseTransformation = '$.category';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateCategoryRequest,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _categoryResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId, options]);
        const reqOpts = ambassadorWixForumV1Category.updateCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a category (only if it is not last category).
 * @param categoryId - ID of category.
 * @internal
 * @documentationMaturity preview
 * @requiredField categoryId
 * @adminMethod
 */
export function deleteCategory(categoryId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { categoryId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteCategoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteCategoryResponse,
            depSchemas: { _category },
            fqdnTransformation: {
                paths: [...['category']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId]);
        const reqOpts = ambassadorWixForumV1Category.deleteCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Subscribes a contact to a specific forum category.
 *
 * By default a contact isn't subscribed to any forum categories.
 *
 * By subscribing a contact to a category, the contact receives notifications for that category.
 *
 * If `contactId` is not provided, it is implicitly resolved from the caller's context.
 * @param categoryId - Category ID.
 * @public
 * @documentationMaturity preview
 * @requiredField categoryId
 * @param options - Options for subscribing the contact.
 * @adminMethod
 */
export function subscribeContactToCategory(categoryId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            categoryId: '$[0]',
            contactId: '$[1].contactId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _subscribeContactToCategoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _subscribeContactToCategoryResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId, options]);
        const reqOpts = ambassadorWixForumV1Category.subscribeContactToCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Unsubscribes a contact from a specific forum category.
 *
 *
 * By default a contact isn't subscribed to any forum categories.
 *
 * By unsubscribing a contact from a category, the contact won’t receive notifications for that category.
 *
 * If `contactId` is not provided, it is implicitly resolved from the caller's context.
 * @param categoryId - Category ID.
 * @public
 * @documentationMaturity preview
 * @requiredField categoryId
 * @param options - Options for unsubscribing the contact.
 * @adminMethod
 */
export function unsubscribeContactFromCategory(categoryId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            categoryId: '$[0]',
            contactId: '$[1].contactId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _unsubscribeContactFromCategoryRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _unsubscribeContactFromCategoryResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([categoryId, options]);
        const reqOpts = ambassadorWixForumV1Category.unsubscribeContactFromCategory(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'categoryId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=forum-v1-category.universal.js.map